import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { StreamType } from '@cds/betting-offer/add-ons';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { TimerModule } from '../timers/timer.module';

@Component({
    selector: 'ms-scoreboard-time',
    templateUrl: 'scoreboard-time.component.html',
    styleUrl: './scoreboard-time.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TimerModule, IconCustomComponent, NgTemplateOutlet],
})
export class ScoreboardTimeComponent {
    @Input() event: EventModel;
    @Input() showStream = false;
    @Input() swapLiveBadge = false;

    constructor(public sitecore: Sitecore) {}

    isVideoStreamAvailable(): boolean {
        const streamType = this.event.stream?.streamType;
        return streamType !== undefined && streamType !== StreamType.FastData;
    }
}
